import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { MamStatus } from "../../../domain/mam-explorer";
import { STATUS_META } from "../mam-explorer.constants";

@Component({
  selector: "evrideo-mam-explorer-status-cell",
  template: `
    <span *ngIf="status" class="mam-status-badge" [ngClass]="cssClass">
      {{ label }}
    </span>
  `,
  styleUrls: ["./mam-explorer-status-cell.component.scss"],
})
export class MamExplorerStatusCellComponent
  implements ICellRendererAngularComp
{
  status: MamStatus | null = null;
  label = "";
  cssClass = "";

  agInit(params: ICellRendererParams): void {
    this.updateDisplay(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.updateDisplay(params);
    return true;
  }

  private updateDisplay(params: ICellRendererParams): void {
    if (!params.data) return;
    this.status = params.data.status;
    if (this.status && STATUS_META[this.status]) {
      this.label = STATUS_META[this.status].label;
      this.cssClass = STATUS_META[this.status].cssClass;
    }
  }
}
